import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@mui/material/ButtonGroup';
import {Button, CircularProgress} from '..';
import {ArrowDropDown} from 'views/icons';
import {PopperMenu} from './Menu';

const SplitButtonDropdown = (props) => {
  const {
    onClickPrimaryButton,
    onClickArrowButton,
    label,
    anchorRef,
    buttonGroupSx,
    loading,
    disabled,
  } = props;

  return (
    <>
      <ButtonGroup
        variant='contained'
        color='primary'
        disableElevation
        disabled={disabled || loading}
        sx={buttonGroupSx || {height: '42px'}}
      >
        <Button anchorref={anchorRef} onClick={onClickPrimaryButton}>
          {loading ?
          <CircularProgress /> :
          label}
        </Button>
        <Button onClick={onClickArrowButton}>
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <PopperMenu
        anchorEl={anchorRef.current}
        zIndex={10000}
        {...props} />
    </>
  );
};
SplitButtonDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  open: PropTypes.bool.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onClickPrimaryButton: PropTypes.func,
  onClickArrowButton: PropTypes.func,
  onClickAway: PropTypes.func,
  onMenuItemClick: PropTypes.func,
  anchorRef: PropTypes.object,
  loading: PropTypes.bool,
  buttonGroupSx: PropTypes.object,
  disabled: PropTypes.bool,
};

export default React.memo(SplitButtonDropdown);
